import { Body, Header } from "../components/index";
import { ContextSystemViewProvider } from "../context/index";

export const LayoutPageSystemView = () => (
  <>
    <ContextSystemViewProvider>
      <Header />
      <Body />
    </ContextSystemViewProvider>
  </>
);
